
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke163aRequest, Sgke163aResponse, Sgke163aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke163aService {

  /**
   * コンストラクタ
   * @param {Sgke163aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke163aService
   */
  constructor(
    public service: Sgke163aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) { }

  /**
   * SGKE163A_入金締め登録API呼び出し
   * @param {Sgke163aRequest} request 
   * @returns {Observable<Sgke163aResponse>}
   * @memberof UsedSgke163aService
   */
  public doSgke163a(request: Sgke163aRequest): Observable<Sgke163aResponse> {
    return this.service.sgke163aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE163A');
          return throwError(err.message);
        })
      );
  }

}
